import { DELIMETER, DISTRIBUTION_SUFFIX } from "./constants";
import { set_feature_flags } from "../../reducers/FeatureFlags/reducer";
import { fetchFlags } from "../../fetch/other/aggregate_api/flags";

export function fetch_feature_flags() {
    return async (dispatch) => {
        const flags = await fetchFlags();

        return dispatch(set_feature_flags(flags));
    };
}

/**
 * @param {Map<string, number|string>} flags
 * @return {Action}
 */
export function update_feature_cohorts(flags) {
    const cohorts = Object.entries(flags).reduce((accum, [key, value]) => {
        if (typeof value === "number" && key.endsWith(DISTRIBUTION_SUFFIX)) {
            let parentKey = key.slice(0, -DISTRIBUTION_SUFFIX.length);
            let cohortKey = `${parentKey}${DELIMETER}cohort`;
            let roll = Math.random();
            let cohort = roll < value ? 0 : 1;
            if (!flags.hasOwnProperty(cohortKey)) {
                accum[cohortKey] = cohort;
            }
        }
        return accum;
    }, {});

    return set_feature_flags(cohorts);
}
